// Código atualizado com blocos unificados: credores e interessados agrupados como blocotexto
import React, { useContext, useEffect, useRef, useState } from "react";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import { IoIosCloseCircle, IoMdCloseCircle } from "react-icons/io";
import Context from '../../Context/Context'

import PessoaDupla from "./PessoaDupla";
import { abreviarMes, formatarListaComE, formatarMoeda, gerarTitulo, getProcesso, horarioParaExtenso, numeroParaExtenso, parseValor } from "./utils/utilsFormularioEdital";
import { handleGerar } from "./services/gerarEdital";
import { estadosBrasil } from "./services/map";
import { handleGerarEditalVeiculo } from "./services/gerarEditalVeiculo";
import { mapChaveamentoEstados } from "./FormularioEditalSP";

const estadosComIndice = ['MS', 'CE', 'MT', 'PE', 'RS', 'TO', 'SE', 'PR']


export default function FormularioEditalVeiculo({ tipoEdital }) {
  const [parteTipo, setParteTipo] = useState("executado");
  const [vara, setVara] = useState("");
  const [foro, setForo] = useState("");
  const [praça, setPraça] = useState("1ª e 2ª praça");
  const [exequentes, setExequentes] = useState([{ nome: "", doc: "" }]);

  const [executados, setExecutados] = useState([
    {
      executado: "",
      doc_executado: "",
      // endereco: "", // <-- novo campo
      cep: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      logradouro: '',
      //
      conjuge: "",
      doc_conjuge: "",
      endereco_conjuge: "", // <-- novo campo
      tem_conjuge: false,
      genero: "m",
    },
  ]);

  const [indice, setIndice] = useState('')
  const [doisIndices, setDoisIndices] = useState(false) // se true desabilita o indice e seta o numInds para '2'
  const [numInds, setNumInds] = useState('1')
  const indiceInput = useRef(null)

  const [credor, setCredor] = useState([{ nome: "", doc: "", endereco: "", genero: "m" }]);
  const [interessado, setInteressado] = useState([{ nome: "", doc: "", endereco: "" }]);
  const [objetoLeilao, setObjetoLeilao] = useState("do bem imóvel abaixo descrito");
  const [doutorTitulo, setDoutorTitulo] = useState("Dr.");
  const [acao, setAcao] = useState("");
  const [partePrincipal, setPartePrincipal] = useState("");
  const [docPartePrincipal, setDocPartePrincipal] = useState(""); // CPF/CNPJ
  const [enderecoPartePrincipal, setEnderecoPartePrincipal] = useState(""); // Endereço
  const [tipoPartePrincipal, setTipoPartePrincipal] = useState("exequente");
  const [processoNumero, setProcessoNumero] = useState("");
  const [tipoBens, setTipoBens] = useState("bem");
  const [localizacaoLote1, setLocalizacaoLote1] = useState("");
  const [descricaoLote1, setDescricaoLote1] = useState("");

  // Caso Paraná
  const [valorCausa, setValorCausa] = useState('')


  // ESTADO - MESES
  const [mes, setMes] = useState("");
  const [mesPraceamento, setMesPraceamento] = useState("");
  const [mesAtualizado, setMesAtualizado] = useState("");

  // ...antes do return...
  const [possuiParcelamento, setPossuiParcelamento] = useState("sim");



  // ESTADO - DECISÃO SOBRE DÉBITO CONDOMINIAL
  const [temDecisaoDebito, setTemDecisaoDebito] = useState(false);
  const [decisaoDebito, setDecisaoDebito] = useState("");

  const [folhasDecisaoDebito, setFolhasDecisaoDebito] = useState(""); // Estado para as folhas da decisão sobre débito condominial

  const [valorDebitosTributariosInscritos, setValorDebitosTributariosInscritos] = useState("");
  const [valorDebitosTributariosNaoInscritos, setValorDebitosTributariosNaoInscritos] = useState("");


  const [pedidoDePenhora, setPedidoDePenhora] = useState("");
  const [anotacaoPenhora, setAnotacaoPenhora] = useState("");
  const [valorPenhora, setValorPenhora] = useState("");
  const [mesPenhora, setMesPenhora] = useState("");
  const [anoPenhora, setAnoPenhora] = useState("");
  const [processoDaPenhora, setProcessoDaPenhora] = useState("");
  const [credorPenhora, setCredorPenhora] = useState("");
  const [diaPraceamento, setDiaPraceamento] = useState("");
  const [anoPraceamento, setAnoPraceamento] = useState("");
  const [horarioPraceamento, setHorarioPraceamento] = useState("10:00");

  const [horarioEncerramento2Praca, setHorarioEncerramento2Praca] = useState("10:00");


  const [responsabilizacaoFraude, setResponsabilizacaoFraude] = useState("sim");



  const [diaEncerramento, setDiaEncerramento] = useState("");
  const [mesEncerramento, setMesEncerramento] = useState("");
  const [anoEncerramento, setAnoEncerramento] = useState("");

  const [diaEncerramento2Praca, setDiaEncerramento2Praca] = useState("");
  const [mesEncerramento2Praca, setMesEncerramento2Praca] = useState("");
  const [anoEncerramento2Praca, setAnoEncerramento2Praca] = useState("");

  const [percentualLance, setPercentualLance] = useState("");
  const [percentualEntrada, setPercentualEntrada] = useState("");
  const [parcelas, setParcelas] = useState("");

  const [comissao, setComissao] = useState("");
  const [comissaoPorExtenso, setComissaoPorExtenso] = useState("");

  const [diaConfeccao, setDiaConfeccao] = useState("");
  const [mesConfeccao, setMesConfeccao] = useState("");

  const [foiHomologado, setFoiHomologado] = useState("sim");

  const [pagina, setPagina] = useState(0);

  const [horarioPraceamentoExtenso, setHorarioPraceamentoExtenso] = useState("");

  const [horarioEncerramento, setHorarioEncerramento] = useState("10:00");
  const [estado, setEstado] = useState('BA')



  // ...existing code...
  const [temDebitosTributarios, setTemDebitosTributarios] = useState("");
  const [valorDebitosTributarios, setValorDebitosTributarios] = useState("");
  const [mesDebitosTributarios, setMesDebitosTributarios] = useState("");
  const [anoDebitosTributarios, setAnoDebitosTributarios] = useState("");

  // ...existing code...
  // ...após os outros useState...
  // ESTADOS PARA O DÉBITO EXEQUENDO GLOBAL (aparece apenas se nenhum lote tiver débito exequendo específico)
  const [valorDebitoExequendoGlobal, setValorDebitoExequendoGlobal] = useState("");
  const [mesDebitoExequendoGlobal, setMesDebitoExequendoGlobal] = useState("");
  const [anoDebitoExequendoGlobal, setAnoDebitoExequendoGlobal] = useState("");
  const [folhasDebitoExequendoGlobal, setFolhasDebitoExequendoGlobal] = useState("");
  const [mostrarFolhasDebitoExequendoGlobal, setMostrarFolhasDebitoExequendoGlobal] = useState(true);
  const [valorHonorariosAdvocaticosGlobal, setValorHonorariosAdvocaticosGlobal] = useState("");

  // ... (mantenha os outros estados existentes)

  //fazenda
  const [fazendaExequente, setFazendaExequente] = useState('sim')

  // ...antes do return...
  const [vendaDireta, setVendaDireta] = useState("sim");

  const [temObsTodosLotes, setTemObsTodosLotes] = useState(false);
  const [obsTodosLotes, setObsTodosLotes] = useState([""]);
  const [bensApreendidos, setBensApreendidos] = useState('nao');



  const [horarioEncerramentoExtenso, setHorarioEncerramentoExtenso] = useState("");
  const [horarioEncerramento2PracaExtenso, setHorarioEncerramento2PracaExtenso] = useState("");
  const { indicacao } = useContext(Context)
  const page = useRef(null);

  useEffect(() => {
    setHorarioEncerramentoExtenso(horarioParaExtenso(horarioEncerramento));
  }, [horarioEncerramento]);

  useEffect(() => {
    setHorarioEncerramento2PracaExtenso(horarioParaExtenso(horarioEncerramento2Praca));;
  }, [horarioEncerramento2Praca]);

  useEffect(() => {
    setHorarioPraceamentoExtenso(horarioParaExtenso(horarioPraceamento));
  }, [horarioPraceamento]);

  // Sempre que o horário mudar, atualize o extenso:


  // ...antes do return...
  const [penhoras, setPenhoras] = useState([
    {
      pedidoDePenhora: "",
      anotacaoPenhora: "",
      valorPenhora: "",
      mesPenhora: "",
      anoPenhora: "",
      processoDaPenhora: "",
      credorPenhora: ""
    }
  ]);



  // ESTADO - MULTILOTES
  // ESTADO - MULTILOTES
  const [lotes, setLotes] = useState([
    {
      localizacao: "",
      descricao: "",
      inscricao: "",
      matricula: "",
      cartorio: "",
      onus: [{ registro: "", data: "", ato: "", processo: "", credor: "" }],
      observacoes: [""],
      valor_avaliacao: "",
      folhas_avaliacao: "",
      folhas_homologacao: "",
      mes: "",
      ano: "",
      valor_atualizado: "",
      mes_atualizado: "",
      ano_atualizado: "",
      debitos_tributarios: "",
      // Removido: debito_condominial: "", // Este campo será substituído por estados mais específicos

      // Novos campos para controle de condomínio/loteamento e débitos por lote
      emCondominio: "", // "sim", "nao", ""
      temDebitoCondominial: "", // "sim", "nao", "sem_info", ""
      trataDebitoCondominialExequendo: "", // "sim", "nao", "" (dentro do bloco condominial)
      valorDebitoCondominial: "", // Valor se NÃO for exequendo
      mesDebitoCondominial: "",
      anoDebitoCondominial: "",
      valorHonorariosCondominial: "", // Honorários se NÃO for exequendo
      valorDebitoCondominialExequendo: "", // Valor se for exequendo
      mesDebitoCondominialExequendo: "",
      anoDebitoCondominialExequendo: "",
      folhasDebitoCondominialExequendo: "",
      mostrarFolhasDebitoCondominialExequendo: true,
      valorHonorariosCondominialExequendo: "", // Honorários se for exequendo


      emLoteamento: "", // "sim", "nao", ""
      trataDebitoAssociativaExequendo: "", // "sim", "nao", "" (dentro do bloco loteamento)
      valorDebitoAssociativa: "", // Valor se NÃO for exequendo
      mesDebitoAssociativa: "",
      anoDebitoAssociativa: "",
      valorHonorariosAssociativa: "", // Honorários se NÃO for exequendo
      valorDebitoAssociativaExequendo: "", // Valor se for exequendo
      mesDebitoAssociativaExequendo: "",
      anoDebitoAssociativaExequendo: "",
      folhasDebitoAssociativaExequendo: "",
      mostrarFolhasDebitoAssociativaExequendo: true,
      valorHonorariosAssociativaExequendo: "", // Honorários se for exequendo
      temDebitosTributarios: '',

      //   cep: "",
      //   logradouro: "",
      //   numero: "",
      //   complemento: "",
      //   bairro: "",
      //   cidade: "",
      //   estado: "",
    },
  ]);


  // ESTADO - RESGUARDAR QUOTA PARTE
  const [resguardarQuota, setResguardarQuota] = useState("");



  const adicionarExecutado = () => {
    setExecutados([
      ...executados,
      {
        executado: "",
        doc_executado: "",
        conjuge: "",
        doc_conjuge: "",
        tem_conjuge: false,
        cep: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        logradouro: '',
      },
    ]);
  };

  const [juiz, setJuiz] = useState({
    nome: "",
    genero: "m",
    endereco: "", // <-- novo campo
  });
  // ...restante do código mantido


  const dias = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, "0"));
  const meses = [
    "janeiro", "fevereiro", "março", "abril", "maio", "junho",
    "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
  ];
  const anos = Array.from({ length: 20 }, (_, i) => String(2025 + i));




  const mesesEnum = [
    { nome: "janeiro", numero: "01" },
    { nome: "fevereiro", numero: "02" },
    { nome: "março", numero: "03" },
    { nome: "abril", numero: "04" },
    { nome: "maio", numero: "05" },
    { nome: "junho", numero: "06" },
    { nome: "julho", numero: "07" },
    { nome: "agosto", numero: "08" },
    { nome: "setembro", numero: "09" },
    { nome: "outubro", numero: "10" },
    { nome: "novembro", numero: "11" },
    { nome: "dezembro", numero: "12" },
  ];


  const anosTodos = Array.from({ length: (new Date().getFullYear() - 1900 + 1) }, (_, i) => String(new Date().getFullYear() - i));
  const anosLeilao = [new Date().getFullYear(), new Date().getFullYear() + 1]


  const [mostrar, setMostrar] = useState({
    credor: true,
    interessado: true,
  });

  const paginas = [
    "Dados do Processo",
    "Partes e Interessados",
    "Informações do Juiz",
    "Informações do(s) Bem(ns)",
    "Condições de Venda",
  ];



  const [generoTitulo, setGeneroTitulo] = useState({
    executado: "m",
    credor: "m",
    interessado: "m",
  });

  // useEffect(() => {
  //   console.log('genero Titulo', generoTitulo)
  //   console.log(parteTipo)
  // }, [generoTitulo, parteTipo])

  const renderListaExequenteRequerente = (lista, setLista, label, tipo) => (
    lista.map((_, i) => (
      <div
        key={i}
        className="border border-gray-200 bg-gray-50 p-5 rounded-3xl shadow-md mb-8 flex flex-col gap-4 transition-transform duration-300 hover:scale-[1.02]"
      >
        <section className="flex justify-between items-center">
          <h3 className="font-semibold text-lg text-neutral-700 capitalize">
            {tipoPartePrincipal === "exequente" ? "🧾 Exequente" : "📄 Requerente"}
          </h3>
          <button
            type="button"
            onClick={() => {
              const novos = [...lista];
              novos.splice(i, 1);
              setLista(novos);
            }}
            className="text-neutral-500 hover:text-red-500 transition"
            title="Remover"
          >
            <IoIosCloseCircle size={22} />
          </button>
        </section>

        <div className="flex flex-col md:flex-row gap-4">
          <input
            type="text"
            placeholder={`Nome do ${tipoPartePrincipal === "exequente" ? "Exequente" : "Requerente"}`}
            value={lista[i].nome}
            onChange={e => {
              const novos = [...lista];
              novos[i].nome = e.target.value;
              setLista(novos);
            }}
            className="ring-1 ring-neutral-300 bg-white p-3 rounded-2xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition"
          />
          <input
            type="text"
            placeholder={`CPF/CNPJ do ${tipoPartePrincipal === "exequente" ? "Exequente" : "Requerente"}`}
            value={lista[i].doc}
            onChange={e => {
              const novos = [...lista];
              novos[i].doc = e.target.value;
              setLista(novos);
            }}
            className="ring-1 ring-neutral-300 bg-white p-3 rounded-2xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition"
          />
        </div>
      </div>
    ))
  );




  const renderLista = (lista, setLista, label, tipo) => (
    <div className="mt-8 relative">
      <label className="flex flex-col gap-3 font-semibold mb-2">
        Há {label}?
        <select
          value={mostrar[tipo] ? "sim" : "nao"}
          onChange={(e) =>
            setMostrar({ ...mostrar, [tipo]: e.target.value === "sim" })
          }
          className="border p-2 rounded-xl bg-white"
        >
          <option value="sim">Sim</option>
          <option value="nao">Não</option>
        </select>
      </label>

      {mostrar[tipo] && (
        <div>
          {lista.map((p, i) => (
            <div
              key={i}
              className="border p-3 mb-3 rounded-md bg-gray-50 flex flex-col shadow-lg transition-transform duration-300 hover:scale-105 gap-2 border-gray-200"
            >
              <div className="mb-2 flex gap-10 relative mb pt-3">
                <div>
                  <label className="block font-medium mb-1">Gênero</label>
                  <select
                    value={p.genero || "m"}
                    onChange={e => {
                      const nova = [...lista];
                      nova[i].genero = e.target.value;
                      setLista(nova);
                    }}
                    className="border border-gray-300 bg-white p-2 rounded-xl shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 !w-auto"
                  >
                    <option value="m">Masculino</option>
                    <option value="f">Feminino</option>
                  </select>
                </div>
                <input
                  type="text"
                  placeholder={`Nome do ${label}`}
                  value={p.nome}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].nome = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`CPF/CNPJ do ${label}`}
                  value={p.doc}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].doc = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`CEP do ${label}`}
                  value={p.cep || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].cep = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`Número do ${label}`}
                  value={p.numero || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].numero = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`Complemento do ${label}`}
                  value={p.complemento || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].complemento = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`Bairro do ${label}`}
                  value={p.bairro || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].bairro = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`Cidade do ${label}`}
                  value={p.cidade || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].cidade = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <input
                  type="text"
                  placeholder={`Logradouro do ${label}`}
                  value={p.logradouro || ""}
                  onChange={(e) => {
                    const nova = [...lista];
                    nova[i].logradouro = e.target.value;
                    setLista(nova);
                  }}
                  className="border border-gray-300 bg-white p-2 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 h-11 mt-6"
                />
                <section
                  type="button"
                  onClick={() => {
                    const nova = [...lista];
                    nova.splice(i, 1);
                    setLista(nova);
                  }}
                  className="text-black px-3 py-1 rounded m-auto flex items-center justify-center absolute top-0 right-0 hover:text-gray-700 transition-transform duration-300 hover:scale-125"
                  title="Excluir"
                >
                  <IoIosCloseCircle fontSize={22} />
                </section>
              </div>
            </div>
          ))}
          <button
            type="button"
            onClick={() => setLista([...lista, { nome: "", doc: "" }])}
            className="bg-black hover:bg-gray-700 text-white px-3 py-2 rounded-xl mt-4 transition-transform duration-300 hover:scale-105"
          >
            + Adicionar {label}
          </button>
        </div>
      )}
    </div>
  );


  // Coloque antes do return principal
  const PaginateBar = () => (
    <div className="flex items-center justify-center mb-10 w-full">
      {paginas.map((titulo, idx) => (
        <div key={idx} className="flex items-center justify-center">
          {/* Círculo da página */}
          <div
            onClick={() => setPagina(idx)}
            className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-semibold shadow transition-all duration-300 cursor-pointer
            ${idx === pagina ? 'bg-black text-white' : 'bg-gray-200 text-gray-500 hover:bg-gray-300'}
          `}
          >
            {idx + 1}
          </div>

          {/* Linha de conexão */}
          {idx < paginas.length - 1 && (
            <div
              className={`h-[2px] mx-3 w-10 rounded-full transition-all duration-300
              ${idx < pagina ? 'bg-black' : 'bg-gray-300'}
            `}
            />
          )}
        </div>
      ))}
    </div>
  );


  // ...existing code...

  // Função para converter string para número (removendo R$, pontos e vírgulas)


  // Soma dos valores de avaliação
  const somaValorAvaliacao = lotes.reduce(
    (acc, lote) => acc + parseValor(lote.valor_avaliacao),
    0
  );

  // Soma dos valores de avaliação atualizada
  const somaValorAtualizado = lotes.reduce(
    (acc, lote) => acc + parseValor(lote.valor_atualizado),
    0
  );

  // Formata para moeda

  useEffect(() => {
    page.current?.scrollIntoView({ behavior: "smooth" });
  }, [pagina])



  // no return:

  return (
    <div ref={page} className="max-w-4xl mx-auto p-8 mt-10 mb-10 rounded-3xl bg-white shadow-sm shadow-neutral-200">

      <PaginateBar />

      {pagina === 0 && (
        <div className="space-y-8">

          {/* CARD 1: Dados do Leilão */}
          <div className="bg-white border border-neutral-200 shadow-sm rounded-3xl p-6 space-y-6">
            <h3 className="text-lg font-semibold text-neutral-800">Informações do Leilão</h3>

            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Estado: </label>
              <select
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
                className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
              >
                {Object.keys(mapChaveamentoEstados[tipoEdital]).map((es, i) => (
                  <option value={es} key={es + i}>
                    {mapChaveamentoEstados[tipoEdital][es]}
                  </option>
                ))}
              </select>
            </div>

            {
              estado == 'CE' && (
                <div className="space-y-2">
                  <label className="text-sm text-neutral-600">👮‍♀️ Bens Apreendidos?</label>
                  <select
                    value={bensApreendidos}
                    onChange={e => {
                      setBensApreendidos(e.target.value);
                    }}
                    className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition shadow-sm"
                  >
                    <option value="nao">Não</option>
                    <option value="sim">Sim</option>
                  </select>
                </div>
              )
            }

            {['PB', 'MS'].includes(estado) && (
              <div className="space-y-2">
                <label className="text-sm text-neutral-500">🏡 A Fazenda Pública é Exequente?
                </label>
                <select
                  value={fazendaExequente}
                  onChange={(e) => setFazendaExequente(e.target.value)}
                  className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
                >
                  <option value="sim">Sim</option>
                  <option value="nao">Não</option>
                </select>
              </div>
            )}

            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Objeto do Leilão</label>
              <select
                value={objetoLeilao}
                onChange={(e) => setObjetoLeilao(e.target.value)}
                className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
              >
                {[
                  "do bem abaixo descrito",
                  "dos bens abaixo descritos",
                  "dos direitos do bem abaixo descrito",
                  "dos direitos dos bens abaixo descritos",
                ].map((val, i) => <option key={i} value={val}>{val}</option>)}
              </select>
            </div>

            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Número do Processo</label>
              <input
                type="text"
                value={processoNumero}
                placeholder="0000000-00.0000.0.00.0000"
                onChange={(e) => setProcessoNumero(e.target.value)}
                onBlur={() => getProcesso(processoNumero, setVara, setForo, juiz, setJuiz, indicacao, setLotes, lotes, exequentes, setExequentes, setEstado)}
                className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Vara"
                value={vara}
                onChange={(e) => setVara(e.target.value)}
                className="bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 w-full focus:ring-2 focus:ring-black focus:outline-none"
              />
              <input
                type="text"
                placeholder="Foro"
                value={foro}
                onChange={(e) => setForo(e.target.value)}
                className="bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 w-full focus:ring-2 focus:ring-black focus:outline-none"
              />
            </div>
          </div>

          {/* CARD 2: Tipo de Parte e Praça */}
          <div className="bg-white border border-neutral-200 shadow-sm rounded-3xl p-6 space-y-6">
            <h3 className="text-lg font-semibold text-neutral-800">Configurações do Processo</h3>

            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Tipo da Parte Principal</label>
              <select
                value={parteTipo}
                onChange={(e) => setParteTipo(e.target.value)}
                className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
              >
                <option value="executado">Executado</option>
                <option value="requerido">Requerido</option>
              </select>
            </div>

            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Tipo de Praça</label>
              <select
                value={praça}
                onChange={(e) => setPraça(e.target.value)}
                className="w-full bg-neutral-50 text-neutral-800 rounded-xl px-4 py-2.5 border border-neutral-300 focus:ring-2 focus:ring-black focus:outline-none"
              >
                <option value="1ª e 2ª praça">1ª e 2ª praça</option>
                <option value="praça Única">Praça Única</option>
              </select>
            </div>
          </div>

          {/* CARD 3: Partes e Cônjuges */}
          {/* CARD do título e botão adicionar */}
          <div className="bg-white border border-neutral-200 shadow-sm !rounded-3xl p-6 space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold text-neutral-800">
                {parteTipo === "executado" ? "Executados" : "Requeridos"} e Cônjuges
              </h3>
              <button
                onClick={adicionarExecutado}
                className="text-sm text-neutral-700 hover:text-white hover:bg-black border border-neutral-300 px-4 py-1.5 rounded-xl transition"
              >
                + Adicionar {parteTipo === "executado" ? "Executado" : "Requerido"}
              </button>
            </div>
          </div>

          {/* LISTA FORA DO CARD – visual plano */}
          <div className="space-y-6 mt-6">
            {executados.map((_, i) => (
              <div key={i} className="relative group">

                {/* Conteúdo do executado (flat, sem bordas) */}
                <PessoaDupla
                  setGeneroTitulo={setGeneroTitulo}
                  generoTitulo={generoTitulo}
                  index={i}
                  dados={executados}
                  setDados={setExecutados}
                  parteTipo={parteTipo}
                />

                {/* Botão de remover flutuante */}
                {executados.length > 1 && (
                  <button
                    onClick={() => {
                      const nova = [...executados];
                      nova.splice(i, 1);
                      setExecutados(nova);
                    }}
                    title="Remover"
                    className="absolute -top-2 -right-2 text-neutral-400 hover:text-red-500 transition"
                  >
                    <IoIosCloseCircle size={22} />
                  </button>
                )}
              </div>
            ))}
          </div>


          {/* CARD 4: Credores e Interessados */}
          <div className="bg-white border border-neutral-200 shadow-sm rounded-3xl p-6 space-y-6">
            <h3 className="text-lg font-semibold text-neutral-800">Demais Partes</h3>
            {renderLista(credor, setCredor, "Credor", "credor")}
            {renderLista(interessado, setInteressado, "Interessado", "interessado")}
          </div>

        </div>
      )}



      {pagina === 1 && (
        <div className="space-y-12 bg-white">

          {/* CARD: Juiz */}
          <div className="rounded-3xl border border-neutral-200 shadow-md px-6 py-8 space-y-8">
            <h2 className="text-xl font-semibold text-neutral-900">🧑‍⚖️ Informações do Juiz</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              {/* Gênero */}
              <div className="space-y-2">
                <label className="text-sm text-neutral-500">Gênero</label>
                <select
                  value={juiz.genero}
                  onChange={(e) => {
                    setJuiz({ ...juiz, genero: e.target.value });
                    setDoutorTitulo(e.target.value === 'm' ? 'Dr.' : 'Dra.');
                  }}
                  className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300"
                >
                  <option value="m">Masculino</option>
                  <option value="f">Feminino</option>
                </select>
              </div>

              {/* Nome */}
              <div className="space-y-2">
                <label className="text-sm text-neutral-500">Nome completo</label>
                <input
                  type="text"
                  placeholder="Ex: João da Silva Júnior"
                  value={juiz.nome}
                  onChange={(e) => setJuiz({ ...juiz, nome: e.target.value })}
                  className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 placeholder:text-neutral-400"
                />
              </div>
            </div>
          </div>

          {/* CARD: Ação + Exequentes */}
          <div className="rounded-3xl border border-neutral-200 shadow-md px-6 py-8 space-y-8">
            <h2 className="text-xl font-semibold text-neutral-900">📄 Ação Judicial</h2>

            {/* Campo de Ação */}
            <div className="space-y-2">
              <label className="text-sm text-neutral-500">Tipo da Ação</label>
              <input
                type="text"
                placeholder="Ex: Ação de Execução por Quantia Certa Contra Devedor Solvente"
                value={acao}
                onChange={(e) => setAcao(e.target.value)}
                className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 placeholder:text-neutral-400"
              />
            </div>

            {/* Lista de Exequentes */}
            <div className="space-y-4">
              {renderListaExequenteRequerente(exequentes, setExequentes, "Exequente", "exequente")}
            </div>

            {/* Botão Adicionar */}
            <div className="pt-2 flex justify-center">
              <button
                onClick={() => setExequentes([...exequentes, { nome: '', doc: '' }])}
                className="bg-black text-white px-6 py-2.5 rounded-2xl font-medium hover:bg-neutral-900 transition"
              >
                + Adicionar {tipoPartePrincipal === "exequente" ? "Exequente" : "Requerente"}
              </button>
            </div>
          </div>

        </div>
      )}



      {/* Exequente/Requerente e Processo */}
      {pagina === 2 && (
        <>
          <div className="mb-8  rounded-xl p-6  flex flex-col gap-4">
            <h2 className="font-semibold text-lg text-black mb-4">Informações do(s) Bem(ns)</h2>
            <div className="mb-4">
              <label className="block font-semibold mb-2 text-gray-700">Tipo</label>
              <select
                value={tipoBens}
                onChange={e => setTipoBens(e.target.value)}
                className="border border-gray-300 bg-white p-3 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
              >
                <option value="bem">Bem</option>
                <option value="bens">Bens</option>
              </select>
            </div>



            <div className="rounded-3xl border border-neutral-200 bg-white shadow-md px-6 py-8 space-y-8">
              <h2 className="text-3xl font-semibold text-center text-neutral-900 tracking-tight">🗂️ Lotes</h2>

              {lotes.map((lote, loteIndex) => (
                <div key={loteIndex} className="relative rounded-3xl bg-white shadow-sm border border-neutral-200 p-6 space-y-6 transition hover:shadow-md">

                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-semibold text-neutral-800 tracking-wide">🏷️ Lote {loteIndex + 1}</h3>

                  </div>

                  <div className="space-y-2">
                    <label className="text-sm text-neutral-600">📍 Localização do Veículo (Visitação)</label>

                    <div className="flex gap-2">
                      <input
                        type="text"
                        placeholder="CEP"
                        value={lote.cep}
                        onChange={(e) => {
                          const novos = [...lotes];
                          novos[loteIndex].cep = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      />
                      <button
                        type="button"
                        onClick={async () => {
                          try {
                            const response = await fetch(`https://viacep.com.br/ws/${lote.cep}/json/`);
                            const data = await response.json();
                            if (!data.erro) {
                              const novos = [...lotes];
                              Object.assign(novos[loteIndex], {
                                logradouro: data.logradouro,
                                bairro: data.bairro,
                                cidade: data.localidade,
                                estado: data.uf
                              });
                              setLotes(novos);
                            } else {
                              alert("CEP não encontrado.");
                            }
                          } catch {
                            alert("Erro ao buscar o CEP.");
                          }
                        }}
                        className="bg-black text-white px-4 py-2 rounded-2xl hover:bg-neutral-800 transition"
                      >
                        Buscar CEP
                      </button>
                    </div>

                    <input
                      type="text"
                      placeholder="Logradouro"
                      value={lote.logradouro}
                      onChange={(e) => {
                        const novos = [...lotes];
                        novos[loteIndex].logradouro = e.target.value;
                        setLotes(novos);
                      }}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black transition-all shadow-sm"
                    />

                    <div className="grid grid-cols-2 gap-4">
                      <input
                        type="text"
                        placeholder="Número"
                        value={lote.numero}
                        onChange={(e) => {
                          const novos = [...lotes];
                          novos[loteIndex].numero = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Complemento"
                        value={lote.complemento}
                        onChange={(e) => {
                          const novos = [...lotes];
                          novos[loteIndex].complemento = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black shadow-sm"
                      />
                    </div>

                    <input
                      type="text"
                      placeholder="Bairro"
                      value={lote.bairro}
                      onChange={(e) => {
                        const novos = [...lotes];
                        novos[loteIndex].bairro = e.target.value;
                        setLotes(novos);
                      }}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black shadow-sm"
                    />

                    <div className="grid grid-cols-2 gap-4">
                      <input
                        type="text"
                        placeholder="Cidade"
                        value={lote.cidade}
                        onChange={(e) => {
                          const novos = [...lotes];
                          novos[loteIndex].cidade = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Estado"
                        value={lote.estado}
                        onChange={(e) => {
                          const novos = [...lotes];
                          novos[loteIndex].estado = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 placeholder:text-neutral-400 focus:ring-2 focus:ring-black shadow-sm"
                      />
                    </div>
                  </div>

                  {/* Descrição */}
                  <div className="space-y-2">
                    <label className="text-sm text-neutral-600">📝 Descrição do imóvel</label>
                    <textarea
                      placeholder="Digite a descrição completa do imóvel..."
                      value={lote.descricao}
                      onChange={e => {
                        const novos = [...lotes];
                        novos[loteIndex].descricao = e.target.value;
                        setLotes(novos);
                      }}
                      className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm resize-none min-h-[120px]"
                    />
                  </div>

                  {/* Dados do imóvel */}
                  <div>
                    <label className="block text-sm font-medium text-neutral-600 mb-2">🚘 Dados do veículo</label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <input
                        type="text"
                        placeholder="Nome do Veículo"
                        value={lote.veiculo}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].veiculo = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Placa do Veículo"
                        value={lote.placa}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].placa = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <input
                        type="text"
                        placeholder="Chassi do Veículo"
                        value={lote.chassi}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].chassi = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Ano/Modelo do Veículo"
                        value={lote.anoModelo}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].anoModelo = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <input
                        type="text"
                        placeholder="Cor do Veículo"
                        value={lote.cor}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].cor = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Renavam do Veículo"
                        value={lote.renavam}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].renavam = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <input
                        type="text"
                        placeholder="Combustível do Veículo"
                        value={lote.combustivel}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].combustivel = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                      <input
                        type="text"
                        placeholder="Potência/Cilindradas do Veículo"
                        value={lote.potenciaCilindradas}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].potenciaCilindradas = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                      />
                    </div>

                    <input
                      type="text"
                      placeholder="Marca do Veículo"
                      value={lote.marca}
                      onChange={e => {
                        const novos = [...lotes];
                        novos[loteIndex].marca = e.target.value;
                        setLotes(novos);
                      }}
                      className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black focus:outline-none transition-all duration-300 shadow-sm"
                    />
                  </div>


                  <div className="mb-10 space-y-6">
                    <h4 className="text-lg font-semibold text-neutral-900 mt-6">⚖️ Ônus</h4>

                    {lote.onus.map((onusItem, i) => (
                      <div
                        key={i}
                        className="relative rounded-2xl border border-neutral-200 bg-white shadow-sm p-6 space-y-6"
                      >
                        <p className="text-base font-semibold text-neutral-700 -mt-2 mb-1">Ônus {i + 1}</p>

                        {/* Linha 1: Registro + Data */}
                        <div className="flex flex-col md:flex-row gap-4">
                          <input
                            type="text"
                            placeholder="📄 Restrição"
                            value={onusItem.restricao}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].onus[i].restricao = e.target.value;
                              setLotes(novos);
                            }}
                            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />

                          {/* Data */}
                          <div className="flex gap-2 w-full">
                            <select
                              value={onusItem.dia || ""}
                              onChange={e => {
                                const novos = [...lotes];
                                novos[loteIndex].onus[i].dia = e.target.value;
                                setLotes(novos);
                              }}
                              className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 focus:ring-2 focus:ring-black transition-all w-1/3"
                            >
                              <option value="">Dia</option>
                              {dias.map(d => (
                                <option key={d} value={d}>{d}</option>
                              ))}
                            </select>

                            <select
                              value={onusItem.mes || ""}
                              onChange={e => {
                                const novos = [...lotes];
                                novos[loteIndex].onus[i].mes = e.target.value;
                                setLotes(novos);
                              }}
                              className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 focus:ring-2 focus:ring-black transition-all w-1/3"
                            >
                              <option value="">Mês</option>
                              {mesesEnum.map(m => (
                                <option key={m.numero} value={m.numero}>{m.numero}</option>
                              ))}
                            </select>

                            <select
                              value={onusItem.ano || ""}
                              onChange={e => {
                                const novos = [...lotes];
                                novos[loteIndex].onus[i].ano = e.target.value;
                                setLotes(novos);
                              }}
                              className="bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 text-neutral-800 focus:ring-2 focus:ring-black transition-all w-1/3"
                            >
                              <option value="">Ano</option>
                              {anosTodos.map(a => (
                                <option key={a} value={a}>{a}</option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Linha 2: Ato / Processo / Credor */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <input
                            type="text"
                            placeholder="📁 Processo"
                            value={onusItem.processo}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].onus[i].processo = e.target.value;
                              setLotes(novos);
                            }}
                            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />
                          <input
                            type="text"
                            placeholder="💼 Credor"
                            value={onusItem.credor}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].onus[i].credor = e.target.value;
                              setLotes(novos);
                            }}
                            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />
                        </div>

                        {/* Botão excluir */}
                        <button
                          type="button"
                          onClick={() => {
                            const novos = [...lotes];
                            novos[loteIndex].onus.splice(i, 1);
                            setLotes(novos);
                          }}
                          className="absolute top-3 right-3 text-neutral-400 hover:text-red-500 transition"
                          title="Excluir Ônus"
                        >
                          <IoIosCloseCircle fontSize={22} />
                        </button>
                      </div>
                    ))}



                    {/* Botão adicionar Ônus */}
                    <button
                      type="button"
                      onClick={() => {
                        const novos = [...lotes];
                        novos[loteIndex].onus.push({
                          registro: "",
                          data: "",
                          ato: "",
                          processo: "",
                          credor: ""
                        });
                        setLotes(novos);
                      }}
                      className="bg-black hover:bg-neutral-800 text-white px-5 py-2.5 rounded-2xl font-medium transition"
                    >
                      + Adicionar Ônus
                    </button>
                  </div>

                  <div>
                    <h4>📝 Observações</h4>

                    {lote?.observacoes.map((e, obsIndex) => (
                      <>
                        <div>
                          <input onChange={({ target }) => {
                            const novos = [...lotes];
                            novos[loteIndex].observacoes[obsIndex] = target.value;
                            setLotes(novos);
                          }} value={e} type="text" />
                          <butto onClick={() => {
                            const novos = [...lotes];
                            novos[loteIndex].observacoes.splice(obsIndex, 1);
                            setLotes(novos);
                          }}> <IoMdCloseCircle className="hover:!bg-transparent" /> </butto>
                        </div>
                      </>
                    ))}

                    <button
                      type="button"
                      onClick={() => {
                        const novos = [...lotes];
                        novos[loteIndex].observacoes.push("");
                        setLotes(novos);
                      }}
                      className="bg-black hover:bg-neutral-800 text-white px-5 py-2.5 rounded-2xl font-medium transition"
                    >
                      + Adicionar Observações
                    </button>
                  </div>

                  <div className="mb-10 space-y-6">
                    <h4 className="text-lg font-semibold text-neutral-900">💰 Valor de Avaliação</h4>

                    {/* Valor */}
                    <div className="space-y-2">
                      <label className="text-sm text-neutral-600">Valor estimado do bem</label>
                      <div className="relative">
                        <input
                          type="text"
                          value={lote.valor_avaliacao}
                          onChange={e => {
                            const novos = [...lotes];
                            novos[loteIndex].valor_avaliacao = e.target.value;
                            setLotes(novos);
                          }}
                          className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm pl-8"
                        />
                        <p className="absolute top-4 left-3 text-neutral-400">R$</p>
                      </div>
                    </div>

                    {/* Mês e Ano */}
                    <div className="grid grid-cols-2 gap-4">
                      <select
                        value={lote.mes}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].mes = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      >
                        <option value="">Mês</option>
                        {meses.map(m => (
                          <option key={m} value={m}>{m}</option>
                        ))}
                      </select>

                      <select
                        value={lote.ano}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].ano = e.target.value;
                          setLotes(novos);
                        }}
                        className="bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      >
                        <option value="">Ano</option>
                        {anosTodos.map(a => (
                          <option key={a} value={a}>{a}</option>
                        ))}
                      </select>
                    </div>

                    {/* Folhas da avaliação */}
                    <div className="space-y-2">
                      <label className="text-sm text-neutral-600">📄 Folhas da Avaliação</label>
                      <input
                        type="text"
                        placeholder="Nº das folhas"
                        value={lote.folhas_avaliacao}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].folhas_avaliacao = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      />
                    </div>

                    {/* Homologação */}
                    <div className="space-y-4">
                      <label className="text-sm text-neutral-600">🔖 Foi homologado?</label>
                      <select
                        value={lote.foiHomologado}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].foiHomologado = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      >
                        <option value="sim">Sim</option>
                        <option value="nao">Não</option>
                      </select>

                      {foiHomologado === "sim" && (
                        <div className="space-y-2">
                          <label className="text-sm text-neutral-600">📑 Folhas da Homologação</label>
                          <input
                            type="text"
                            placeholder="Nº das folhas homologadas"
                            value={lote.folhas_homologacao}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].folhas_homologacao = e.target.value;
                              setLotes(novos);
                            }}
                            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />
                        </div>
                      )}
                    </div>
                  </div>



                  <div className="mb-10 space-y-6">
                    {/* DÉBITOS TRIBUTÁRIOS */}
                    <div className="space-y-4">
                      <label className="text-sm text-neutral-600">💼 Débitos Tributários?</label>
                      <select
                        value={lotes[loteIndex].tem_debitos_tributarios}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].tem_debitos_tributarios = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      >
                        <option value="">Selecione</option>
                        <option value="sim">Sim</option>
                        <option value="nao">Não</option>
                        <option value="sem_info">Sem Informação</option>
                      </select>

                      {lotes[loteIndex].tem_debitos_tributarios === "sim" && (
                        <div className="">
                          <input
                            value={lotes[loteIndex].debitos_tributarios}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].debitos_tributarios = e.target.value;
                              setLotes(novos);
                            }}
                            type="text"
                            placeholder="Debitos Tributários"
                            className="bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />
                        </div>
                      )}
                    </div>

                    <div>
                      <label>📅 Data da consulta:</label>
                      <input
                        value={lotes[loteIndex].data_consulta}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].data_consulta = e.target.value;
                          setLotes(novos);
                        }}
                        type="text"
                        placeholder="Data da consulta"
                        className="bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      />
                    </div>


                    <div className="space-y-4">
                      <label className="text-sm text-neutral-600">🔧 Tem Recall?</label>

                      <select
                        value={lotes[loteIndex].tem_recall}
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].tem_recall = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                      >
                        <option value="">Selecione</option>
                        <option value="sim">Sim</option>
                        <option value="nao">Não</option>
                        <option value="sem_info">Sem Informação</option>
                      </select>

                      {lotes[loteIndex].tem_recall === "sim" && (
                        <div className="grid col-span-full grid-cols-1 gap-4 mt-2">
                          <input
                            value={lotes[loteIndex].recall}
                            onChange={e => {
                              const novos = [...lotes];
                              novos[loteIndex].recall = e.target.value;
                              setLotes(novos);
                            }}
                            type="text"
                            placeholder="Recall"
                            className="bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm text-neutral-600">👤 Dados do fiel depositário</label>
                    <input
                      type="text"
                      placeholder="Nome do fiel depositário"
                      value={lote.fiel_depositario}
                      onChange={e => {
                        const novos = [...lotes];
                        novos[loteIndex].fiel_depositario = e.target.value;
                        setLotes(novos);
                      }}
                      className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm !mb-2"
                    />

                    <div className="flex gap-5">
                      <select
                        onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].tipo_doc_fiel = e.target.value;
                          setLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                        value={lote.tipo_doc_fiel} name="" id="">
                        <option value="">Selecione</option>
                        <option value="RG">RG</option>
                        <option value="CPF">CPF</option>
                      </select>

                      <input
                        placeholder="N° do documento"
                        value={lote.fiel_doc}
                        className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm" type="text" onChange={e => {
                          const novos = [...lotes];
                          novos[loteIndex].fiel_doc = e.target.value;
                          setLotes(novos);
                        }} />
                    </div>
                  </div>


                  <button
                    type="button"
                    onClick={() => {
                      const novos = [...lotes];
                      novos.splice(loteIndex, 1);
                      setLotes(novos);
                    }
                    }
                    className=" text-black px-3 py-2 rounded-xl mt-4 transition-transform duration-300  hover:scale-105 absolute top-0 right-0"
                  >
                    <IoIosCloseCircle fontSize={22} />
                  </button>
                </div>

              ))}



              <button
                type="button"
                onClick={() => setLotes([...lotes, {
                  localizacao: "",
                  descricao: "",
                  inscricao: "",
                  matricula: "",
                  cartorio: "",
                  onus: [{ registro: "", data: "", ato: "", processo: "", credor: "" }],
                  observacoes: [""],
                }])}
                className="bg-black hover:bg-gray-700 text-white px-3 py-2 rounded-xl mt-4 transition-transform duration-300  hover:scale-105"
              >
                + Adicionar Lote
              </button>

            </div>

            {/* Observações para todos os lotes */}
            <div className="space-y-4">
              <div className="space-y-2">
                <label className="text-sm text-neutral-600">📝 Observações para todos os lotes?</label>
                <select
                  value={temObsTodosLotes ? "sim" : "nao"}
                  onChange={e => {
                    setTemObsTodosLotes(e.target.value === "sim");
                    if (e.target.value === "nao") setObsTodosLotes([""]);
                  }}
                  className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition shadow-sm"
                >
                  <option value="nao">Não</option>
                  <option value="sim">Sim</option>
                </select>
              </div>

              {temObsTodosLotes && (
                <div className="space-y-2">
                  <label className="text-sm text-neutral-600">📌 Observações</label>
                  {obsTodosLotes.map((obs, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <input
                        type="text"
                        placeholder={`Obs ${obsTodosLotes.length > 1 ? String(i + 1).padStart(2, "0") : ""}`}
                        value={obs}
                        onChange={e => {
                          const novos = [...obsTodosLotes];
                          novos[i] = e.target.value;
                          setObsTodosLotes(novos);
                        }}
                        className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black shadow-sm"
                      />
                      {obsTodosLotes.length > 1 && (
                        <button
                          type="button"
                          onClick={() => {
                            const novos = [...obsTodosLotes];
                            novos.splice(i, 1);
                            setObsTodosLotes(novos);
                          }}
                          title="Remover"
                          className="text-black hover:text-red-600"
                        >
                          <IoIosCloseCircle fontSize={22} />
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => setObsTodosLotes([...obsTodosLotes, ""])}
                    className="bg-black text-white text-sm px-4 py-2 rounded-2xl hover:bg-neutral-800 transition"
                  >
                    + Adicionar Observação
                  </button>
                </div>
              )}
            </div>

            {/* Penhora no rosto dos autos */}
            <div className="mt-10 space-y-4">
              <h4 className="text-lg font-semibold text-black">⚖️ Penhora no rosto dos autos</h4>

              <div className="grid grid-cols-5 gap-4 text-sm text-neutral-600 font-medium">
                <span>Requerimento</span>
                <span>Anotação</span>
                <span>Valor</span>
                <span>Proc. nº</span>
                <span>Credores</span>
              </div>

              {penhoras.map((penhora, idx) => (
                <div key={idx} className="grid grid-cols-5 gap-4 items-center relative">
                  <input
                    type="text"
                    placeholder="Requerimento"
                    value={penhora.pedidoDePenhora}
                    onChange={e => {
                      const novos = [...penhoras];
                      novos[idx].pedidoDePenhora = e.target.value;
                      setPenhoras(novos);
                    }}
                    className="bg-neutral-100 px-3 py-2 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-sm"
                  />
                  <input
                    type="text"
                    placeholder="Anotação"
                    value={penhora.anotacaoPenhora}
                    onChange={e => {
                      const novos = [...penhoras];
                      novos[idx].anotacaoPenhora = e.target.value;
                      setPenhoras(novos);
                    }}
                    className="bg-neutral-100 px-3 py-2 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-sm"
                  />
                  <input
                    type="text"
                    placeholder="R$ 0,00"
                    value={penhora.valorPenhora}
                    onChange={e => {
                      const novos = [...penhoras];
                      novos[idx].valorPenhora = e.target.value;
                      setPenhoras(novos);
                    }}
                    className="bg-neutral-100 px-3 py-2 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-sm"
                  />
                  <input
                    type="text"
                    placeholder="Proc. nº"
                    value={penhora.processoDaPenhora}
                    onChange={e => {
                      const novos = [...penhoras];
                      novos[idx].processoDaPenhora = e.target.value;
                      setPenhoras(novos);
                    }}
                    className="bg-neutral-100 px-3 py-2 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-sm"
                  />
                  <input
                    type="text"
                    placeholder="Credores"
                    value={penhora.credorPenhora}
                    onChange={e => {
                      const novos = [...penhoras];
                      novos[idx].credorPenhora = e.target.value;
                      setPenhoras(novos);
                    }}
                    className="bg-neutral-100 px-3 py-2 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-sm"
                  />

                  {penhoras.length > 1 && (
                    <button
                      type="button"
                      onClick={() => {
                        const novos = [...penhoras];
                        novos.splice(idx, 1);
                        setPenhoras(novos);
                      }}
                      title="Excluir"
                      className="absolute -right-8 top-1 text-black hover:text-red-600"
                    >
                      <IoIosCloseCircle fontSize={22} />
                    </button>
                  )}
                </div>
              ))}

              <button
                type="button"
                onClick={() =>
                  setPenhoras([...penhoras, {
                    pedidoDePenhora: "",
                    anotacaoPenhora: "",
                    valorPenhora: "",
                    mesPenhora: "",
                    anoPenhora: "",
                    processoDaPenhora: "",
                    credorPenhora: ""
                  }])
                }
                className="bg-black text-white text-sm px-4 py-2 rounded-2xl hover:bg-neutral-800 transition"
              >
                + Adicionar Penhora
              </button>
            </div>


            {lotes.every(lote =>
              lote.trataDebitoCondominialExequendo !== "sim" &&
              lote.trataDebitoAssociativaExequendo !== "sim"
            ) && (
                <div className="space-y-5 mt-8">
                  <h3 className="text-lg font-semibold text-black">⚖️ Débito Exequendo (Global)</h3>

                  {/* Valor */}
                  <div className="relative">
                    <label className="text-sm text-neutral-600 block mb-1">💰 Valor</label>
                    <input
                      type="text"
                      value={valorDebitoExequendoGlobal}
                      onChange={e => setValorDebitoExequendoGlobal(e.target.value)}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800 placeholder:text-neutral-400 shadow-sm pl-8"
                    />
                    <p className="absolute top-10 left-3 text-neutral-400">R$</p>
                  </div>

                  {/* Mês e Ano */}
                  <div className="grid grid-cols-2 gap-4">
                    <select
                      value={mesDebitoExequendoGlobal}
                      onChange={e => setMesDebitoExequendoGlobal(e.target.value)}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
                    >
                      <option value="">📆 Mês</option>
                      {meses.map(m => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                    <select
                      value={anoDebitoExequendoGlobal}
                      onChange={e => setAnoDebitoExequendoGlobal(e.target.value)}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
                    >
                      <option value="">📅 Ano</option>
                      {anosTodos.map(a => (
                        <option key={a} value={a}>{a}</option>
                      ))}
                    </select>
                  </div>

                  {estado == 'PR' && (
                    <div className="flex gap-2 flex-col">
                      <label className="text-sm text-neutral-600 block mb-2">
                        💰 Valor Da Causa
                        <input className="mt-2 w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800 placeholder:text-neutral-400 shadow-sm" type="number" value={valorCausa} onChange={(e) => setValorCausa(e.target.value)} />
                      </label>
                    </div>
                  )}

                  {/* Honorários */}


                  {/* Folhas - seletor */}
                  <div className="space-y-2">
                    <label className="text-sm text-neutral-600 block">📄 Adicionar número de folhas?</label>
                    <select
                      value={mostrarFolhasDebitoExequendoGlobal ? "sim" : "nao"}
                      onChange={e => {
                        setMostrarFolhasDebitoExequendoGlobal(e.target.value === "sim");
                        if (e.target.value !== "sim") setFolhasDebitoExequendoGlobal("");
                      }}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
                    >
                      <option value="sim">Sim</option>
                      <option value="nao">Não</option>
                    </select>

                    {mostrarFolhasDebitoExequendoGlobal && (
                      <input
                        type="text"
                        placeholder="Nº das folhas"
                        value={folhasDebitoExequendoGlobal}
                        onChange={e => setFolhasDebitoExequendoGlobal(e.target.value)}
                        className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800 placeholder:text-neutral-400 shadow-sm"
                      />
                    )}
                  </div>
                </div>
              )}
          </div>
          <div className="space-y-6">
            <div>
              <label className="block text-sm text-neutral-600 mb-1">📑 Há decisão sobre débitos condominiais?</label>
              <select
                value={temDecisaoDebito ? "sim" : "nao"}
                onChange={e => {
                  const val = e.target.value;
                  setTemDecisaoDebito(val === "sim");
                  if (val !== "sim") {
                    setDecisaoDebito("");
                    setFolhasDecisaoDebito("");
                  }
                }}
                className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
              >
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </div>

            {temDecisaoDebito && (
              <div className="space-y-4">
                <div>
                  <label className="block text-sm text-neutral-600 mb-1">🧾 Tipo de decisão</label>
                  <select
                    value={decisaoDebito}
                    onChange={e => {
                      setDecisaoDebito(e.target.value);
                      if (e.target.value !== "sub-rogado") setFolhasDecisaoDebito("");
                    }}
                    className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
                  >
                    <option value="">Selecione</option>
                    <option value="sub-rogado">Sub-rogado</option>
                    <option value="nao_sub-rogado">Não Sub-rogado</option>
                  </select>
                </div>

                {decisaoDebito === "sub-rogado" && (
                  <div>
                    <label className="block text-sm text-neutral-600 mb-1">📄 Folhas da decisão</label>
                    <input
                      type="text"
                      placeholder="Ex: 22/24"
                      value={folhasDecisaoDebito}
                      onChange={e => setFolhasDecisaoDebito(e.target.value)}
                      className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800 placeholder:text-neutral-400 shadow-sm"
                    />
                  </div>
                )}
              </div>
            )}
          </div>


          {lotes.length > 1 && (
            <div className="mb-8 rounded-2xl bg-neutral-100 ring-1 ring-neutral-300 p-6 shadow-sm space-y-4">
              <div>
                <h4 className="text-base font-medium text-neutral-700 mb-1">📊 Valor total de avaliação</h4>
                <p className="text-lg font-semibold text-black">{formatarMoeda(somaValorAvaliacao)}</p>
              </div>
              <div>
                <h4 className="text-base font-medium text-neutral-700 mb-1">📈 Valor atualizado de avaliação</h4>
                <p className="text-lg font-semibold text-black">{formatarMoeda(somaValorAtualizado)}</p>
              </div>
            </div>
          )}

          <div className="mb-8 space-y-3">
            <label className="block text-sm text-neutral-600">📌 Resguardar quota-parte?</label>
            <select
              value={resguardarQuota}
              onChange={(e) => setResguardarQuota(e.target.value)}
              className="w-full bg-neutral-100 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black text-neutral-800"
            >
              <option value="">Não resguardar</option>
              <option value="resguardar">💡 Deságio recairá apenas sobre a quota-parte do executado</option>
            </select>
          </div>




        </>
      )}

      {pagina === 3 && (
        <>
          <div className="mb-8 !w-full">
            <label className="block font-semibold text-neutral-700 mb-2">📅 Datas da Praça</label>

            {/* Início */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 !w-full">
              <select value={diaPraceamento} onChange={e => setDiaPraceamento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                <option value="">Dia início</option>
                {dias.map(d => <option key={d} value={d}>{d}</option>)}
              </select>
              <select value={mesPraceamento} onChange={e => setMesPraceamento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                <option value="">Mês início</option>
                {meses.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
              <select value={anoPraceamento} onChange={e => setAnoPraceamento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                <option value="">Ano início</option>
                {anosLeilao.map(a => <option key={a} value={a}>{a}</option>)}
              </select>
              <select
                type="text"
                placeholder="🕒 Horário início"
                value={horarioPraceamento}
                onChange={e => {
                  setHorarioPraceamento(e.target.value);
                  setHorarioEncerramento(e.target.value);
                  setHorarioEncerramento2Praca(e.target.value);
                }}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800"
              >
                <option value="10:00">Horário início</option>
                <option value="13:00">13:00</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="Digite Aqui">outro</option>
              </select>
            </div>

            {!["10:00", "13:00", "14:00", "14:30", "15:00", "15:30", "16:00"].includes(horarioPraceamento) && (
              <div className="flex !justify-end !w-[100%]">
                <input 
                onChange={e => {
                  setHorarioPraceamento(e.target.value);
                  setHorarioEncerramento(e.target.value);
                  setHorarioEncerramento2Praca(e.target.value);
                }}
                value={horarioPraceamento}
                className="ring-1 !w-auto ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800" type="text" />
              </div>
            )}



            {horarioPraceamentoExtenso && (
              <div className="text-xs text-gray-500 mb-3">{horarioPraceamentoExtenso}</div>
            )}

            {/* Encerramento */}
            <div className="border-t pt-4 mt-4">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                <select value={diaEncerramento} onChange={e => setDiaEncerramento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                  <option value="">Dia encerramento</option>
                  {dias.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
                <select value={mesEncerramento} onChange={e => setMesEncerramento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                  <option value="">Mês encerramento</option>
                  {meses.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
                <select value={anoEncerramento} onChange={e => setAnoEncerramento(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                  <option value="">Ano encerramento</option>
                  {anosLeilao.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
                <select
                  type="text"
                  placeholder="🕒 Horário encerramento"
                  value={horarioEncerramento}
                  onChange={e => setHorarioEncerramento(e.target.value)}
                  className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800"
                >
                  <option value="10:00">🕒 Horário encerramento</option>
                  <option value="13:00">13:00</option>
                  <option value="14:00">14:00</option>
                  <option value="14:30">14:30</option>
                  <option value="15:00">15:00</option>
                  <option value="15:30">15:30</option>
                  <option value="16:00">16:00</option>
                  <option value="outro">outro</option>

                </select>


              </div>
             {!["10:00", "13:00", "14:00", "14:30", "15:00", "15:30", "16:00"].includes(horarioPraceamento) && (
              <div className="flex !justify-end !w-[100%]">
                <input 
                onChange={e => {
                  setHorarioPraceamento(e.target.value);
                  setHorarioEncerramento(e.target.value);
                  setHorarioEncerramento2Praca(e.target.value);
                }}
                value={horarioPraceamento}
                className="ring-1 !w-auto ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800" type="text" />
              </div>
            )}
              {horarioEncerramentoExtenso && (
                <div className="text-xs text-gray-500 mb-3">{horarioEncerramentoExtenso}</div>
              )}
            </div>

            {/* 2ª Praça */}
            {praça === "1ª e 2ª praça" && (
              <div className="border-t pt-6 mt-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                  <select value={diaEncerramento2Praca} onChange={e => setDiaEncerramento2Praca(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                    <option value="">Dia encerramento 2ª praça</option>
                    {dias.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                  <select value={mesEncerramento2Praca} onChange={e => setMesEncerramento2Praca(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                    <option value="">Mês encerramento 2ª praça</option>
                    {meses.map(m => <option key={m} value={m}>{m}</option>)}
                  </select>
                  <select value={anoEncerramento2Praca} onChange={e => setAnoEncerramento2Praca(e.target.value)} className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800">
                    <option value="">Ano encerramento 2ª praça</option>
                    {anosLeilao.map(a => <option key={a} value={a}>{a}</option>)}
                  </select>
                  <select
                    type="text"
                    placeholder="🕒 Horário 2ª praça"
                    value={horarioEncerramento2Praca}
                    onChange={e => setHorarioEncerramento2Praca(e.target.value)}
                    className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800"
                  >
                    <option value="10:00">🕒 Horário 2ª praça</option>
                    <option value="13:00">13:00</option>
                    <option value="14:00">14:00</option>
                    <option value="14:30">14:30</option>
                    <option value="15:00">15:00</option>
                    <option value="15:30">15:30</option>
                    <option value="16:00">16:00</option>
                    <option value="outro">outro</option>
                  </select>
                </div>
                {!["10:00", "13:00", "14:00", "14:30", "15:00", "15:30", "16:00"].includes(horarioPraceamento) && (
              <div className="flex !justify-end !w-[100%]">
                <input 
                onChange={e => {
                  setHorarioPraceamento(e.target.value);
                  setHorarioEncerramento(e.target.value);
                  setHorarioEncerramento2Praca(e.target.value);
                }}
                value={horarioPraceamento}
                className="ring-1 !w-auto ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800" type="text" />
              </div>
            )}
                {horarioEncerramento2PracaExtenso && (
                  <div className="text-xs text-gray-500 mt-1">{horarioEncerramento2PracaExtenso}</div>
                )}
              </div>
            )}
          </div>
          <div className="mb-6 mt-6">
            <label className="block font-medium text-neutral-700 mb-2">📉 Percentual mínimo do lance para 2ª praça (%)</label>
            <div className="!relative">
              <input
                type="text"
                placeholder="Ex: 60"
                value={percentualLance}
                onChange={e => setPercentualLance(e.target.value)}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 text-neutral-800 !pl-8"
              />
              <p className="!absolute top-3 left-3 text-neutral-500 ">%</p>
            </div>
          </div>
          <div className="mb-6">
            <label className="block font-medium text-neutral-700 mb-2">📄 Há possibilidade de parcelamento?</label>
            <select
              value={possuiParcelamento}
              onChange={e => setPossuiParcelamento(e.target.value)}
              className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm w-full text-neutral-800"
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>
          </div>

          {possuiParcelamento === "sim" && (
            <div className="flex flex-col gap-0 mb-6">
              <label className="block font-medium text-neutral-700">💰 Percentual de entrada (ex: 25%)</label>
              <input
                type="text"
                value={percentualEntrada}
                onChange={e => {
                  let val = e.target.value.replace(/\D/g, "");
                  if (val) val = `${parseInt(val, 10)}%`;
                  setPercentualEntrada(val);
                }}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800 shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
                inputMode="numeric"
                pattern="[0-9]*"
              />
              <input
                type="number"
                placeholder="🔢 Quantidade de parcelas"
                value={parcelas}
                onChange={e => setParcelas(e.target.value)}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800 shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
                min={1}
              />
            </div>
          )}

          <div className="mb-6 relative">
            <label className="block font-medium text-neutral-700 mb-2">📊 Comissão do Leiloeiro (%)</label>
            <input
              type="text"
              value={comissao}
              onChange={e => {
                setComissao(e.target.value);
                setComissaoPorExtenso(numeroParaExtenso(e.target.value));
              }}
              className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300 text-neutral-800 pl-8"
            />
            <p className="absolute top-11 left-3 text-neutral-500">%</p>
            <input
              type="text"
              placeholder="Comissão por extenso"
              value={comissaoPorExtenso}
              readOnly
              className="ring-1 ring-neutral-200 bg-gray-100 p-3 rounded-2xl text-sm w-full text-neutral-700 mt-2"
            />
          </div>

          <div className="mb-6">
            <label className="block font-medium text-neutral-700 mb-2">⚖️ Responsabilização por fraude no leilão?</label>
            <select
              value={responsabilizacaoFraude}
              onChange={e => setResponsabilizacaoFraude(e.target.value)}
              className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm w-full text-neutral-800"
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>
          </div>

          <div className="mb-6">
            <label className="block font-medium text-neutral-700 mb-2">🛒 Venda Direta?</label>
            <select
              value={vendaDireta}
              onChange={e => setVendaDireta(e.target.value)}
              className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800 w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>
          </div>

          <div className="mb-6">
            <label className="block font-medium text-neutral-700 mb-2">🗓️ Data de Confecção</label>
            <div className="grid grid-cols-2 gap-2">
              <select
                value={diaConfeccao}
                onChange={e => setDiaConfeccao(e.target.value)}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800 w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
              >
                <option value="">Dia</option>
                {dias.map(d => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
              <select
                value={mesConfeccao}
                onChange={e => setMesConfeccao(e.target.value)}
                className="ring-1 ring-neutral-300 bg-neutral-100 p-3 rounded-2xl text-sm text-neutral-800 w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
              >
                <option value="">Mês</option>
                {meses.map(m => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
            </div>
          </div>



        </>


      )}

      <div>
        <div className="max-w-4xl mx-auto p-8 rounded-xl">

          {pagina === 4 && (
            <div className="flex flex-col justify-center items-center w-full gap-4">
              {/* Finalizar */}
              <div className="text-center text-gray-900 font-bold text-xl mb-4">
                Revise os dados e clique em "Gerar Edital"
              </div>
              <button
                onClick={() => handleGerarEditalVeiculo(
                  executados,
                  formatarListaComE,
                  gerarTitulo,
                  parteTipo,
                  generoTitulo,
                  objetoLeilao,
                  doutorTitulo,
                  acao,
                  partePrincipal,
                  docPartePrincipal,
                  processoNumero,
                  tipoBens,
                  localizacaoLote1, // Note: localizacaoLote1 e descricaoLote1 parecem ser remanescentes de um único lote. handleGerar precisará processar o array 'lotes'.
                  descricaoLote1,   // handleGerar precisará processar o array 'lotes'.
                  mes, // Este 'mes' parece não ser usado na interface atual, verificar se é necessário em handleGerar
                  mesPraceamento,
                  mesAtualizado, // Este 'mesAtualizado' parece não ser usado na interface atual, verificar se é necessário em handleGerar
                  temDecisaoDebito,
                  decisaoDebito,
                  folhasDecisaoDebito, // Usar o nome corrigido
                  resguardarQuota,
                  credor,
                  mostrar,
                  percentualLance,
                  interessado,
                  possuiParcelamento,
                  percentualEntrada,
                  parcelas,
                  temDebitosTributarios, // Este parece ser global, verificar se é o desejado
                  valorDebitosTributarios, // Este parece ser global, verificar se é o desejado
                  abreviarMes,
                  mesDebitosTributarios, // Este parece ser global, verificar se é o desejado
                  anoDebitosTributarios, // Este parece ser global, verificar se é o desejado
                  valorDebitosTributariosInscritos, // Este parece ser global, verificar se é o desejado
                  valorDebitosTributariosNaoInscritos, // Este parece ser global, verificar se é o desejado
                  vendaDireta,
                  praça,
                  // REMOVIDOS os estados globais de débito condominial e exequendo antigos:
                  // temDebitoCondominial, valorDebitoCondominial, mesDebitoCondominial, anoDebitoCondominial, valorHonorariosAdvocaticos,
                  // valorDebitoExequendo, mesDebitoExequendo, anoDebitoExequendo, mostrarFolhasDebitoExequendo, trataDebitoExequendo, folhasDebitoExequendo,

                  // ADICIONADOS os novos estados globais para o "Outro Débito Exequendo":
                  valorDebitoExequendoGlobal,
                  mesDebitoExequendoGlobal,
                  anoDebitoExequendoGlobal,
                  mostrarFolhasDebitoExequendoGlobal,
                  folhasDebitoExequendoGlobal,
                  valorHonorariosAdvocaticosGlobal,

                  // Penhoras (parece que você tinha penhoras e penhora singular, mantendo o array penhoras)
                  penhoras, // Passando o array de penhoras

                  diaEncerramento,
                  mesEncerramento,
                  anoEncerramento,
                  horarioEncerramentoExtenso, // so usar lá na map
                  diaEncerramento2Praca,
                  mesEncerramento2Praca,
                  anoEncerramento2Praca,
                  horarioEncerramento2PracaExtenso,

                  diaPraceamento,
                  anoPraceamento,
                  horarioParaExtenso, // Função utilitária
                  horarioPraceamento,
                  horarioEncerramento,
                  horarioEncerramento2Praca,
                  horarioPraceamentoExtenso,


                  lotes, // O array de lotes agora contém as informações de débito por lote
                  foiHomologado,
                  comissao,
                  comissaoPorExtenso,
                  juiz,
                  vara,
                  foro,
                  diaConfeccao,
                  mesConfeccao,
                  temObsTodosLotes,
                  obsTodosLotes,
                  somaValorAvaliacao,
                  somaValorAtualizado,
                  // REMOVIDO penhoras duplicado
                  PizZip, // Utilitário
                  Docxtemplater, // Utilitário
                  saveAs, // Utilitário
                  responsabilizacaoFraude,
                  // REMOVIDO folhasDebitoExequendo duplicado
                  formatarMoeda, // Utilitário
                  exequentes,
                  setExequentes,
                  estado,
                  valorCausa,
                  indice,
                  numInds,
                  fazendaExequente,
                  bensApreendidos,
                )}
                className="reset-button !bg-black !transition !text-white font-semibold !px-10 !rounded-lg shadow mt-8 w-full !text-lg !cursor-pointer !tracking-wider hover:!bg-gray-800"
              >
                Gerar Edital
              </button>

            </div>
          )}

          <div className="flex justify-between mt-8">
            <button
              disabled={pagina === 0}
              onClick={() => setPagina(pagina - 1)}
              className={`px-4 py-2 rounded ${pagina === 0 ? 'bg-gray-300 text-gray-500' : 'bg-black hover:bg-gray-700 text-white'}`}
            >
              Anterior
            </button>
            <button
              disabled={pagina === paginas.length - 1}
              onClick={() => setPagina(pagina + 1)}
              className={`px-4 py-2 rounded ${pagina === paginas.length - 1 ? 'bg-gray-300 text-gray-500' : 'bg-black hover:bg-gray-700 text-white'}`}
            >
              Próximo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
